import BaseModelAPI from '../BaseModelAPI';

export default class SchedulerConfigurationList extends BaseModelAPI {

	static entity = 'schedulerconfigurationlist'
	static entityName = 'schedulerconfiguration';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
